import * as React from 'react';

const CreditCardBackRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <g id="symbol-credit-card-rebranding">
            <g id="fill">
                <path d="M11 15H16V16H11V15Z" fill="#161719" />
                <path d="M19 15H17V16H19V15Z" fill="#161719" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1 7C1 5.34315 2.34315 4 4 4H20C21.6569 4 23 5.34315 23 7V17C23 18.6569 21.6569 20 20 20H4C2.34315 20 1 18.6569 1 17V7ZM4 6H20C20.5523 6 21 6.44771 21 7V8H3V7C3 6.44772 3.44772 6 4 6ZM3 10V17C3 17.5523 3.44772 18 4 18H20C20.5523 18 21 17.5523 21 17V10H3Z"
                    fill="#161719"
                />
            </g>
        </g>
    </svg>
);

CreditCardBackRebrandingSvg.displayName = 'CreditCardBackRebrandingSvg';
export default CreditCardBackRebrandingSvg;
